/**
 * zh/cn（中華人民共和国）の地図をゼンリンいつもNAVIで表示
 * @param {Attr} 緯度経度や地名の情報
 */
import scroller from '../v1/v1Scroller';

// setting
const setZenrinMap = function(option) { // eslint-disable-line
  const _this = this; // eslint-disable-line

  if (!option) return;

  if (!option.mapFeature) return;
  _this.feature = option.mapFeature;

  if (!option.mapOption) return;
  _this.mapOption = option.mapOption;

  _this.iconBase = option.iconBase || '';
  _this.bounds = option.bounds || '';
};

setZenrinMap.prototype.init = function() { // eslint-disable-line
  const _this = this; // eslint-disable-line

  try {
    // カレント履歴 infoWindowを閉じたときのフォーカス操作で使う
    _this.strage = null;

    // Create map
    _this.map = _this.addMAp(_this.mapOption);

    _this.map.addWidget(new ZDC.ScaleBar()); // eslint-disable-line
    _this.map.addWidget(
      new ZDC.Control({ // eslint-disable-line
        type: ZDC.CTRL_TYPE_ZM, // eslint-disable-line
      }),
    );

    // Create markers & InfoWindow
    Array.prototype.forEach.call(_this.feature, (item, index) => {
      const marker = _this.addMarker(item);
      _this.map.addWidget(marker);

      const infowindow = new ZDC.MsgInfo(_this.getLatLon(item.latlng), { // eslint-disable-line
        html: _this.getInfoContent(item.name),
        offset: new ZDC.Pixel(0, -48), // eslint-disable-line
      });
      _this.map.addWidget(infowindow);

      // クリックで開く
      ZDC.addListener(marker, ZDC.MARKER_MOUSEDOWN, function() { // eslint-disable-line
        _this.changeCurrent(index);
      });

      // 閉じたらカレントを解除
      ZDC.addListener(infowindow, ZDC.MSGINFO_CLOSE, function() { // eslint-disable-line
        _this.changeCurrent(null);
      });

      item.marker = marker; // eslint-disable-line
      item.infowindow = infowindow; // eslint-disable-line
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('Failed to get ZDC');
  }
};

/**
 * 選択変更
 * @param {Number} 配列内の自分の番号
 * @param {String} イベント 'keyboard' だとフォーカス操作を行う
 */
setZenrinMap.prototype.changeCurrent = function(current, event) { // eslint-disable-line
  const _this = this; // eslint-disable-line
  Array.prototype.forEach.call(_this.feature, (item, index) => {
    if (index !== current) {
      // その他を閉じる
      item.infowindow.close();
      item.marker.setZindex(100 + index);
      item.listDom.setAttribute('aria-selected', false);
    } else {
      // カレントを開く
      item.infowindow.open();
      item.marker.setZindex(999);
      item.listDom.setAttribute('aria-selected', true);
    }
  });
  // リストが下に来るレイアウトの場合は選択したら地図までスクロール
  if (window.innerWidth < 1024) scroller.toElement(_this.mapOption.target);
  // 閉じたときフォーカスを一覧で最後に選択していた要素へ移動
  if (current === null && _this.strage !== null) {
    const { listDom } = _this.feature[_this.strage];
    setTimeout(() => {
      listDom.focus();
    }, 100);
  }
  // カレント履歴更新
  _this.strage = current;

  // 中心点を設定
  _this.setCenter();
};

/**
 * ゼンリンいつもNAVI 測地系変換
 * @param {Array} 緯度経度
 * @return {ZDC.LatLon} 測地系変換された緯度経度インスタンス
 */
setZenrinMap.prototype.getLatLon = function(latlng) { // eslint-disable-line
  return new ZDC.wgsTotky(new ZDC.LatLon(+latlng[0], +latlng[1])); // eslint-disable-line
};

/**
 * ゼンリンいつもNAVI 地図生成
 * @param {Object} 表示エリア、緯度経度、倍率、中心点
 * @return {ZDC.map} インスタンス化された地図
 */
setZenrinMap.prototype.addMAp = function(option) { // eslint-disable-line
  const result = new ZDC.Map(option.target, { // eslint-disable-line
    latlon: new ZDC.LatLon(0, 0), // eslint-disable-line
    zoom: 3,
    mapType: ZDC.MAPTYPE_KANTAI, // eslint-disable-line
  });
  return result;
};

/**
 * ゼンリンいつもNAVI マーカーを建てる
 * @param {Object} 緯度経度、アイコン画像パス
 * @return {ZDC.Marker} インスタンス化されたマーカー
 */
setZenrinMap.prototype.addMarker = function(item) { // eslint-disable-line
  const _this = this; // eslint-disable-line
  return new ZDC.Marker(_this.getLatLon(item.latlng), { // eslint-disable-line
    offset: new ZDC.Pixel(-21, -52), // eslint-disable-line
    custom: {
      base: {
        src: `${item.icon}`,
        imgSize: new ZDC.WH(42, 52), // eslint-disable-line
      },
    },
  });
};

/**
 * すべてのマーカーがおさまる表示範囲を設定
 */
setZenrinMap.prototype.setCenter = function() { // eslint-disable-line
  const _this = this; // eslint-disable-line
  const latlons = [
    _this.getLatLon([_this.bounds.sw.lat, _this.bounds.sw.lng]), // 南西
    _this.getLatLon([_this.bounds.ne.lat, _this.bounds.ne.lng]), // 北東
  ];
  const bounds = _this.map.getAdjustZoom(latlons, false);
  _this.map.setZoom(bounds.zoom);
  _this.map.moveLatLon(bounds.latlon);
  _this.map.refresh();
};

/**
 * GoogleMapの吹き出し内ソース
 * @param {String} 表示名称 Nagasaki+Airport
 * @return {String} 吹き出し内のソース
 */
setZenrinMap.prototype.getInfoContent = function(name) { // eslint-disable-line
  const _this = this; // eslint-disable-line

  const result = `<div class="v1-itineraryMap__info">
<strong class="v1-itineraryMap__info-title">${name}</strong>
</div>`;
  return result;
};

// EXPORT
export default option => new setZenrinMap(option); // eslint-disable-line
